export enum ApprovalType {
  Approved = 'approved',
  Declined = 'declined'
}
